// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"99f99d85","557":"b069afde"}[chunkId] + ".chunk.js";
};